import { render, staticRenderFns } from "./SubmitConfig.vue?vue&type=template&id=32d66188&scoped=true"
import script from "./SubmitConfig.vue?vue&type=script&lang=ts"
export * from "./SubmitConfig.vue?vue&type=script&lang=ts"
import style0 from "./SubmitConfig.vue?vue&type=style&index=0&id=32d66188&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d66188",
  null
  
)

export default component.exports